import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { amplitudeLogEvent } from '@flow/libs/client-analytics/amplitude';
import { getUtmSource } from '@flow/libs/utils/utm';

import { getGuestToken } from '@flow/libs/agreement/selectors';
import { getCurrentWorkspaceIdSelector } from '@app/reducers/app';
import { getPositionFromSessionSelector } from '@app/reducers/session';
import useAgreement from '@app/hooks/use-agreement';

export const useTrackOpenDocument = (agreementId: Oneflow.Agreement['id']) => {
  const utmSource = getUtmSource();
  const agreement = useAgreement(agreementId);
  const guestToken = useSelector(getGuestToken);
  const position = useSelector(getPositionFromSessionSelector);
  const workspaceId = useSelector(getCurrentWorkspaceIdSelector);

  return useCallback(() => {
    if (!agreement?.owner?.id) {
      return;
    }

    const { id } = position as Oneflow.Position;
    const isOwner = id === agreement.owner.id;

    let participantType = 'guest';
    if (!guestToken) {
      participantType = isOwner ? 'owner' : 'colleague';
    }

    amplitudeLogEvent(
      'Open Document',
      {
        location: utmSource,
        'participant type': participantType,
        'workspace id': workspaceId,
      },
      {
        'document id': agreementId,
      },
    );
  }, [
    guestToken,
    agreementId,
    agreement?.owner?.id,
    position,
    workspaceId,
    utmSource,
  ]);
};
